import angular from 'angular';
import cloneDeep from 'clone-deep';

/* @ngInject */
export default function ($scope, LayoutService, FormService, toastr, $state, moment, $uibModal, AuthService, uuid, FormVersions, $stateParams, Forms) {
	AuthService.redirectIfUnauthorized('forms-management-view', 'splash.home');

	$scope.formId = $stateParams.formId;

	$scope.loading = true;

	$scope.elementTypeAttributes = FormService.getElementTypeAttributes();

	$scope.activeTabs = {
		views: 0,
	};

	$scope.version = {
		version:  '',
		elements: [],
	};

	$scope.refresh = () => {
		$scope.loading = true;

		Forms.one($scope.formId)
		     .get()
		     .then((form) => {
			     $scope.form    = form;
			     $scope.loading = false;

			     $scope.updateLayout($scope.form.title);
		     })
		     .catch((error) => {
			     toastr.clear();
			     toastr.error('There was an error while loading the form, please try again.', 'Error');

			     $state.go('staff.forms.management.versions.view', {
				     formId: $scope.formId,
			     });

			     $scope.loading = false;
		     });
	};

	$scope.addElement = (elementType) => {
		let lastRow = 0;

		angular.forEach($scope.version.elements, (element) => {
			lastRow = Math.max(lastRow, element.layoutRow);
		});

		lastRow++;

		let element = {
			...cloneDeep(FormService.getElementTypeValues(elementType)),
			layoutRow:    lastRow,
			layoutColumn: 1,
		};

		$scope.version.elements.push(element);
	};

	$scope.removeElement = (index) => {
		$scope.version.elements.splice(index, 1);
	};

	$scope.addSelectionOption = (values) => {
		values.push({
			id:    uuid.v4(),
			value: '',
		});
	};

	$scope.removeSelectionOption = (values, index) => {
		values.splice(index, 1);
	};

	$scope.save = () => {
		const errors = FormService.validate($scope.version);

		if (errors.length === 0) {
			const version = FormService.getPostableVersion($scope.version);

			Forms.one($scope.formId)
			     .post('versions', version)
			     .then((returnedVersion) => {
				     toastr.clear();
				     toastr.success('The version was created successfully.', 'Version Created');

				     $state.go('staff.forms.management.view', {
					     formId: $scope.formId,
				     });
			     })
			     .catch((data) => {
				     toastr.clear();
				     toastr.error('There was an error while creating the version, please try again.', 'Error');
			     });
		} else {
			let uniqueErrors = [
				...new Set(errors),
			];

			uniqueErrors = uniqueErrors.map((error) => {
				return `<li>${error}</li>`;
			});

			uniqueErrors = uniqueErrors.join('');

			toastr.clear();
			toastr.warning(`<ul>${uniqueErrors}</ul>`, 'Warning', {
				allowHtml: true,
			});
		}
	};

	$scope.updateLayout = (formName = 'Loading...') => {
		LayoutService.reset();

		LayoutService.setTitle([
			'New Version',
			formName,
			'Management',
			'Forms',
		]);

		LayoutService.getPageHeader()
		             .setBreadcrumbs([
			             {
				             route:       'staff.dashboard',
				             displayName: 'Dashboard',
			             },
			             {
				             route:       'staff.forms.root',
				             displayName: 'Forms',
			             },
			             {
				             route:       'staff.forms.management.root',
				             displayName: 'Management',
			             },
			             {
				             route:       `staff.forms.management.view({ formId: "${$scope.formId}" })`,
				             displayName: formName,
			             },
			             {
				             route:       `staff.forms.management.versions.new({ formId: "${$scope.formId}" })`,
				             displayName: 'New Version',
			             },
		             ]);

		LayoutService.getPageHeader()
		             .setActionButton('<button type="button" class="btn btn-primary pull-right"><i class="fa fa-check"></i> Save</button>');

		LayoutService.getPageHeader()
		             .onClicked($scope.save);
	};

	$scope.updateLayout();
	$scope.refresh();
};


// WEBPACK FOOTER //
// ./src/js/endpoints/staff/forms/management/versions/new/controller.js